import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { PackageType } from './package-type'
import { environment } from '../../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PackageTypeService extends RestClientPaged<PackageType, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly packageTypeServiceApi = environment.apiPath + '/packages/types'

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/packages/types', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * GET Routes                                                              *
   *                                                                         *
   **************************************************************************/

  public getCommonTypesByProcessPlanIds(planIds: string[]): Observable<PackageType[]> {
    return this.http.get<PackageType[]>(this.packageTypeServiceApi + '/common', {
      params: HttpParamsBuilder.start()
        .appendFilters([new Filter('ids', planIds + '')])
        .build(),
    })
  }
}
